import { breakpoints } from 'dibs-sassy/exports/breakpoints.ts';

const MAX_IMAGE_CONTAINER_WIDTH_DESKTOP = 700;
const MAX_IMAGE_CONTAINER_WIDTH_TABLET = 305;
export const SRC_SET_WIDTHS = [
    MAX_IMAGE_CONTAINER_WIDTH_TABLET,
    MAX_IMAGE_CONTAINER_WIDTH_DESKTOP,
    //retina screens
    MAX_IMAGE_CONTAINER_WIDTH_TABLET * 2,
    MAX_IMAGE_CONTAINER_WIDTH_DESKTOP * 2,
];
export const SIZES = `(max-width: ${breakpoints.tabletLandscape.max}px) ${MAX_IMAGE_CONTAINER_WIDTH_TABLET}px, ${MAX_IMAGE_CONTAINER_WIDTH_DESKTOP}px`;
